export const breakpoints = {
  xs: 414,
  sm: 768,
  md: 992,
  lg: 1200
};
